export function logAxiosRequest(config: any) {
  const base = config.baseURL ?? '';
  console.log('[axios request]', {
    baseURL: base,
    url: config.url,
    method: config.method,
    full: base + config.url,
  });
  return config;
}
